import type { List } from '@gonfalon/immutable-shim/immutableShim';
import { fromJS, Record } from '@gonfalon/immutable-shim/immutableShim';
import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';

// type WeightedVariation struct {
// 	Variation int  `json:"variation" bson:"variation"`
// 	Weight    int  `json:"weight" bson:"weight"` // Ranges from 0 to 100000
//  Untracked bool `json:"_untracked"
// }
type WeightedVariationProps = { variation: number; weight: number; _untracked?: boolean };

export class WeightedVariation extends Record<WeightedVariationProps>({
  variation: 0,
  weight: 0,
  _untracked: undefined,
}) {}

export function createWeightedVariation(props: CreateFunctionInput<WeightedVariation> = {}) {
  return props instanceof WeightedVariation ? props : new WeightedVariation(fromJS(props));
}

export const sortFallThroughVariations = (variations: List<WeightedVariation>) =>
  variations.sort((a, b) => (a.variation > b.variation ? 1 : -1));
